<template>
  <div class="certificate-container">
    <div class="patent">
      <div class="patent-work">
        <p>专利与著作权</p>
        <p>PATENT AND COPYRIGHT</p>
      </div>
      <div class="count-box">
        <div>发明专利超<span class="count">5</span>项</div>
        <div class="two">外观设计专利超<span class="count">10</span>项</div>
        <div>软件著作权超<span class="count">40</span>项</div>
      </div>
    </div>
    <swiper ref="HomeSwiper" :options="swiperOption">
      <swiper-slide v-for="(slide, index) in honorData" :key="index">
        <img
          class="slide-img"
          preview
          preview-text="荣誉资质"
          :src="slide.picture | imgFilters"
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
export default {
  props: {
    honorData: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    imgFilters(src) {
      return process.env.VUE_APP_IMAGE_BASE_URL + src;
    },
  },
  data() {
    return {
      swiperOption: {
        autoplay: {
          autoplay: true,
          delay: 1500,
        },
        slidesPerView: 5,
        slidesPerGroup: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 2,
        },
      },
      swiperSlides: [],
    };
  },
};
</script>
<style lang="scss" scoped>
.patent {
  display: flex;
  justify-content: space-around;
  margin-bottom: 159px;
  align-items: flex-end;
  .patent-work {
    font-size: 26px;
    p:nth-child(2) {
      line-height: 0;
    }
  }
  .count-box {
    display: flex;
    align-items: baseline;
    .count {
      color: #336699;
      font-size: 89px;
      font-style: italic;
    }
  }
}
.certificate-container {
  width: 100%;
  margin-top: 50px;
  .slide-img {
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
    width: 80%;
    display: block;
    margin: auto;
    margin-bottom: 100px;
  }
}
</style>
